$(document).ready(function () {
  $('.home-feature-products').owlCarousel({
    loop: true,
    margin: 10,
    dots: true,
    nav: true,

    responsive: {
      0: {
        items: 1,
        stagePadding: 60
      },
      600: {
        items: 2,
        stagePadding: 70
      },
      1000: {
        items: 3,
        stagePadding: 100
      },
      1400: {
        items: 3,
        stagePadding: 290
      }
    }
  });

  /**
   * Accordion
  */
  //Add Inactive Class To All Accordion Headers
  $('.accordion-header').toggleClass('inactive-header');

  //Set The Accordion Content Width
  var contentwidth = $('.accordion-header').width();
  $('.accordion-content').css({ 'width': contentwidth });

  //Open The First Accordion Section When Page Loads
  $('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
  $('.accordion-content').first().slideDown().toggleClass('open-content');

  // The Accordion Effect
  $('.accordion-header').click(function () {
    if ($(this).is('.inactive-header')) {
      $('.active-header').toggleClass('active-header').toggleClass('inactive-header').next().slideToggle().toggleClass('open-content');
      $(this).toggleClass('active-header').toggleClass('inactive-header');
      $(this).next().slideToggle().toggleClass('open-content');
    }

    else {
      $(this).toggleClass('active-header').toggleClass('inactive-header');
      $(this).next().slideToggle().toggleClass('open-content');
    }
  });

  $(".nextProductPhoto").click(function () {
    var activeThumb = document.getElementsByClassName("active-thumb");
    var nextThumb = $(activeThumb).parents('.product-single__thumbnail-list').next().find("a.product-single__thumbnail");
    if (nextThumb) {
      $(nextThumb).click();
    }
  });

  $(".prevProductPhoto").click(function () {
    var activeThumb = document.getElementsByClassName("active-thumb");
    var prevThumb = $(activeThumb).parents('.product-single__thumbnail-list').prev().find("a.product-single__thumbnail");
    if (prevThumb) {
      $(prevThumb).click();
    }
  });


  /*
  $(".site-nav__link, .site-nav__dropdown-link").click(function (e) {
    var link = $(this).attr('href');
    console.log(link);
    if (link == "/") {
      e.preventDefault();
    }
  });
  */


});
